import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RequestStatus } from "@app/constants";

import { IRequestFailed, IFindTestDriveState, IUserInfoPayload } from "./types";

const initialState: IFindTestDriveState = {
  finedTestDrive: {},
  locationFindAll: {},
  bookTestDrive: {},
  orderBookTestDrive: {},
  userInfo: {},
};

const slice = createSlice({
  name: "testDrive",
  initialState,
  reducers: {
    finedTestDrive(state, action: PayloadAction) {
      state.finedTestDrive.status = RequestStatus.RUNNING;
    },
    finedTestDriveSuccess(state, action) {
      state.finedTestDrive.status = RequestStatus.SUCCESS;
      state.finedTestDrive.data = action.payload;
    },
    finedTestDriveFailed(state, action: PayloadAction<IRequestFailed>) {
      state.finedTestDrive.status = RequestStatus.ERROR;
      state.finedTestDrive.error = action.payload;
    },
    locationFindAll(state, action: PayloadAction) {
      state.locationFindAll.status = RequestStatus.RUNNING;
    },
    locationFindAllSuccess(state, action) {
      state.locationFindAll.status = RequestStatus.SUCCESS;
      state.locationFindAll.data = action.payload;
    },
    locationFindAllFailed(state, action: PayloadAction<IRequestFailed>) {
      state.locationFindAll.status = RequestStatus.ERROR;
      state.locationFindAll.error = action.payload;
    },
    bookTestDrive(state, action: PayloadAction<any>) {
      state.bookTestDrive.status = RequestStatus.RUNNING;
    },
    bookTestDriveSuccess(state, action) {
      state.bookTestDrive.status = RequestStatus.SUCCESS;
      state.bookTestDrive.data = action.payload;
    },
    bookTestDriveFailed(state, action: PayloadAction<IRequestFailed>) {
      state.bookTestDrive.status = RequestStatus.ERROR;
      state.bookTestDrive.error = action.payload;
    },
    orderBookTestDrive(state, action: PayloadAction<any>) {
      state.orderBookTestDrive.status = RequestStatus.RUNNING;
    },
    orderBookTestDriveSuccess(state, action) {
      state.orderBookTestDrive.status = RequestStatus.SUCCESS;
      state.orderBookTestDrive.data = action.payload;
    },
    orderBookTestDriveFailed(state, action: PayloadAction<IRequestFailed>) {
      state.orderBookTestDrive.status = RequestStatus.ERROR;
      state.orderBookTestDrive.error = action.payload;
    },
    userInfo(state, action: PayloadAction<IUserInfoPayload>) {
      state.userInfo.status = RequestStatus.RUNNING;
    },
    userInfoSuccess(state, action) {
      state.userInfo.status = RequestStatus.SUCCESS;
      state.userInfo.data = action.payload;
    },
    userInfoFailed(state, action: PayloadAction<IRequestFailed>) {
      state.userInfo.status = RequestStatus.ERROR;
      state.userInfo.error = action.payload;
    },
    resetUserInfo(state) {
      state.userInfo = initialState.userInfo;
    },
  },
});

export default slice.reducer;
export const {
  finedTestDrive,
  finedTestDriveSuccess,
  finedTestDriveFailed,
  locationFindAll,
  locationFindAllSuccess,
  locationFindAllFailed,
  bookTestDrive,
  bookTestDriveSuccess,
  bookTestDriveFailed, 
  orderBookTestDrive, 
  orderBookTestDriveSuccess, 
  orderBookTestDriveFailed,
  userInfo,
  userInfoSuccess,
  userInfoFailed,
  resetUserInfo,
} = slice.actions;
